export { default } from './FakeTooltip';
